import Vue from 'vue'
import Vuex from 'vuex'
import VuexPersistence from 'vuex-persist'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    active: {
      index: 0
    },
    timeline2: [
      // {
      //   index: 0,
      //   meta: true,
      //   type: 'video',
      //   file: 'OCS-Updates_01-Amanda_Desktop_web.mp4',
      //   poster: 'videos/OCS-Updates_01-Amanda_Desktop_web.jpg',
      //   fileMobile: 'OCS-Updates_01-Amanda_Mobile_web.mp4',
      //   posterMobile: 'videos/OCS-Updates_01-Amanda_Mobile_web.png',
      //   id: 'overhead-cups',
      // },
      {
        index: 0,
        type: 'question',
        meta: true, // indicates this isn't a question that contributes to the results, but is instead the intro
        id: 'quiz-intro',
        preload: [
          // 'lockup-overlays/quiz_intro-overlay--left@2x.png',
          'lockup-overlays/intro--left.png',
          // 'lockup-overlays/quiz_intro-overlay--right@2x.png',
          'lockup-overlays/intro--right.png',
          // 'videos/overhead_cups.png',
          // 'videos/overhead_cups--mobile.png',
          'lockup-backgrounds/quiz_04-bg--mobile@2x.jpg',
          'lockup-backgrounds/quiz_04-bg@2x.jpg',
          // 'lockup-cups/intro-cup@2x.png'
        ]
      },
      {
        index: 1,
        type: 'question',
        meta: false,
        key: 'number',
        id: 'question-one',
        preload: [
          'lockup-overlays/quiz_01-overlay--bottom@2x.png',
          'lockup-overlays/quiz_01-overlay--left@2x.png',
          'lockup-overlays/quiz_01-overlay--top@2x.png',
          'lockup-overlays/quiz_01-overlay--right@2x.png',
          'videos/ocs_gears.png',
          'videos/ocs_gears--mobile.png',
          'lockup-backgrounds/quiz_01-bg--mobile@2x.jpg',
          'lockup-backgrounds/quiz_01-bg@2x.jpg'
        ]
      },
      {
        index: 2,
        type: 'question',
        meta: false,
        key: 'role',
        id: 'question-two',
        preload: [
          'lockup-overlays/quiz_02-overlay--bottom@2x.png',
          'lockup-overlays/quiz_02-overlay--left@2x.png',
          'lockup-overlays/quiz_02-overlay--right@2x.png',
          'videos/magic_cups.png',
          'videos/magic_cups--mobile.png',
          'lockup-backgrounds/quiz_02-bg--mobile@2x.jpg',
          'lockup-backgrounds/quiz_02-bg@2x.jpg',
          'lockup-cups/coffee-plays-image.png'
        ]
      },
      {
        index: 3,
        type: 'question',
        meta: false,
        key: 'mostImportant',
        id: 'question-three',
        preload: [
          'lockup-overlays/quiz_03-overlay--bottom@2x.png',
          'lockup-overlays/quiz_03-overlay--left@2x.png',
          'lockup-overlays/quiz_03-overlay--right@2x.png',
          'videos/bean_patterns.png',
          'videos/bean_patterns--mobile.png',
          'lockup-backgrounds/quiz_03-bg--mobile@2x.jpg',
          'lockup-backgrounds/quiz_03-bg@2x.jpg',
          'lockup-cups/important-thing-image.png'
        ]
      },
      {
        index: 4,
        type: 'question',
        meta: false,
        key: 'drinkFor',
        id: 'question-four',
        preload: [
          'lockup-overlays/quiz_04-overlay--bottom@2x.png',
          'lockup-overlays/quiz_04-overlay--left@2x.png',
          'lockup-overlays/quiz_04-overlay--right@2x.png',
          'lockup-overlays/quiz_04-overlay--top@2x.png',
          'videos/overhead_beans.png',
          'videos/overhead_beans--mobile.png',
          'lockup-backgrounds/quiz_04-bg--mobile@2x.jpg',
          'lockup-backgrounds/quiz_04-bg@2x.jpg',
          'lockup-cups/coffee-because-image.png'
        ]
      },
      {
        index: 5,
        type: 'question',
        meta: false,
        key: 'in',
        id: 'question-five',
        preload: [
          'lockup-overlays/quiz_05-overlay--bottom@2x.png',
          'lockup-overlays/quiz_05-overlay--left@2x.png',
          'lockup-overlays/quiz_05-overlay--right@2x.png',
          'videos/to_go_cups.png',
          'videos/to_go_cups--mobile.png',
          'lockup-backgrounds/quiz_05-bg--mobile@2x.jpg',
          'lockup-backgrounds/quiz_05-bg@2x.jpg',
          'lockup-cups/we-serve-coffee-image.png'
        ]
      },
      {
        index: 6,
        type: 'question',
        meta: false,
        key: 'offsite',
        id: 'question-six',
        preload: [
          'lockup-overlays/quiz_06-overlay--bottom@2x.png',
          'lockup-overlays/quiz_06-overlay--left@2x.png',
          'lockup-overlays/quiz_06-overlay--right@2x.png',
          'lockup-backgrounds/quiz_06-bg--mobile@2x.jpg',
          'lockup-backgrounds/quiz_06-bg@2x.jpg',
          'lockup-cups/offsite-image.png'
        ]
      },
      {
        index: 7,
        type: 'question',
        meta: false, // adding results to the indicator
        id: 'results',
        preload: []
      },
    ],
    timeline3: [
      {
        index: 0,
        meta: true,
        type: 'video',
        file: '01_82435-office-coffee-video-v4-v2-comp.mp4',
        poster: 'videos/video-poster.png',
        fileMobile: '01_82435-office-coffee-video-v4-v2-comp.mp4',
        posterMobile: 'videos/video-poster.png',
        id: 'overhead',
      },
    ],
    audioState: false,
    quiz: {
      number: '',
      role: '',
      in: [],
      mostImportant: '',
      drinkFor: '',
      offsite: null
    },
    results: {
      persona: { },
      personaCalculated: '',
      complete: false
    },
    sampleForm: true,
    showCTA: false,
    reCaptchaToken: false,
    payload: '',
    products: [],
    format: '',
    brand: '',
    filterMode: '',
    offersUnlocked: false,
    supplierStarted: false,
    supplierVisibleForm: '',
    formOffers: {
      sampleKit: false,
      rebate: false,
    },
  },
  mutations: {
    setActive (state, index) {
      // console.log('setActive', state.active, index)
      if (typeof index !== 'undefined') {
        this.state.active.index = index
      } else {
        let newIndex = state.active.index + 1
        this.state.active.index = newIndex
      }
    },
    setActiveToEnd (state) {
      this.state.active.index = state.timeline2.length - 1
    },
    toggleAudio (state) {
      state.audioState = !state.audioState
    },
    setQuizValue(state, payload) {
      state.quiz[payload.question] = payload.value
    },
    // addToQuizArray(state, payload) {
    //   state.quiz[payload.question].push(payload.value)
    // },
    setPersonaFromCalc(state, payload) {
      // console.log('setPersonaFromCalc', payload);
      if (payload.persona) {
        state.results.persona = payload.persona
      }
      if (payload.personaCalculated) {
        state.results.personaCalculated = payload.personaCalculated
      }
    },
    completeUnlock(state) {
      state.offersUnlocked = true
    },
    resetStateToInitial(state) {
      state.active.index = 0
      state.audioState = false
      state.quiz.number = '100-200'
      state.quiz.role = ''
      state.quiz.in = []
      state.quiz.mostImportant = ''
      state.quiz.drinkFor = ''
      state.quiz.offsite = null
      state.results.persona = { }
      state.results.personaCalculated = ''
      state.results.complete = false
      state.sampleForm = true
      state.showCTA = false
      state.products = []
      state.format = ''
      state.brand = ''
      state.filterMode = ''
      state.offersUnlocked = false,
      state.supplierStarted = false
      state.supplierVisibleForm = ''
      state.formOffers = {
        sampleKit: false,
        rebate: false,
      }
    },
    resetQuizValues(state) {
      state.active.index = 0
      state.quiz.number = ''
      state.quiz.role = ''
      state.quiz.in = []
      state.quiz.mostImportant = ''
      state.quiz.drinkFor = ''
      state.quiz.offsite = null
      state.results.persona = { }
      state.results.personaCalculated = ''
      state.results.complete = false
      state.sampleForm = true
      state.products = []
      state.format = ''
      state.brand = ''
      state.filterMode = ''
    },
    resetQuizSoft(state) {
      // for forced persona switch, keep number of employees
      state.quiz.role = ''
      state.quiz.in = []
      state.quiz.mostImportant = ''
      state.quiz.drinkFor = ''
      state.quiz.offsite = null
      state.results.persona = { }
      state.products = []
      state.format = ''
      state.brand = ''
      state.filterMode = ''
    },
    setCtaToFalse(state) {
      state.showCTA = false
    },
    setSampleForm(state, payload){
      if (typeof payload == 'boolean') {
        state.sampleForm = payload
      }
    },
    setComplete(state, payload) {
      if (typeof payload === 'boolean') {
        state.results.complete = payload
      }
    },
    setReCaptchaVerified(state, payload) {
      // token or false
      state.reCaptchaToken = payload
    },
    setFormat(state, payload) {
      state.format = payload
      state.filterMode = 'format'
    },
    setBrand(state, payload) {
      state.brand = payload
      state.filterMode = 'brand'
    },
    setProducts(state, payload) {
      state.products = payload
    },
    setSupplierStarted(state, payload) {
      state.supplierStarted = payload
    },
    setVisibleForm(state, payload) {
      state.supplierVisibleForm = payload
    },
    setFormOffers(state, payload) {
      state.formOffers = payload
    }
  },
  actions: {
    startFirst (context) {
      // console.log('startFirst')
      context.commit('setActive', 0)
    },
    advanceTimeline (context) {
      // console.log('advanceTimeline')
      context.commit('setActive')
    },
    setTimeline (context, index) {
      // console.log('setTimeline')
      context.commit('setActive', index)
    },
    setTimelineForResults (context) {
      context.commit('setActiveToEnd', 'results')
    },
    toggleAudio (context) {
      context.commit('toggleAudio')
    },
    changeQuizValue (context, payload) {
      // if (typeof payload.type !== 'undefined') {
      //   context.commit('addToQuizArray', payload)
      // } else {
        context.commit('setQuizValue', payload)
      // }
    },
    personaUpdateFromCalc (context, payload) {
      // console.log('personaUpdateFromCalc', payload);
      context.commit('setPersonaFromCalc', payload)
    },
    resetState (context) {
      context.commit('resetStateToInitial')
    },
    dismissCTA (context) {
      context.commit('setCtaToFalse')
    },
    completed (context, payload) {
      context.commit('setComplete', payload)
    },
    showSampleForm (context, payload){
      context.commit('setSampleForm', payload)
    },
    verifyReCaptcha (context, payload) {
      context.commit('setReCaptchaVerified', payload)
    },
    pickFormat (context, payload) {
      context.commit('setFormat', payload)
    },
    pickBrand (context, payload) {
      context.commit('setBrand', payload)
    },
    products (context, payload) {
      context.commit('setProducts', payload)
    },
    resetQuiz (context) {
      context.commit('resetQuizValues')
    },
    completeUnlockAction (context) {
      context.commit('completeUnlock')
    },
    startSupplier (context) {
      context.commit('setSupplierStarted', true)
    },
    showOfferForm (context) {
      context.commit('setVisibleForm', 'offers')
    },
    showSupportForm (context) {
      // console.log('showSupportForm')
      context.commit('setVisibleForm', 'support')
    },
    forcePersona (context, payload) {
      context.commit('setPersonaFromCalc', payload) // {payload.personaCalculated = string}
      context.commit('resetQuizSoft')
    }
  },
  getters: {
    videos: state => {
      return state.timeline2.filter(i => i.type === 'video')
    },
    supplierVideos: state => {
      return state.timeline3.filter(i => i.type === 'video')
    },
    questions: state => {
      return state.timeline2.filter(i => i.type === 'question')
    },
    questionsActual: state => {
      return state.timeline2.filter(i => i.type === 'question' && !i.meta)
    },
    currentIndex: state => {
      return state.active.index
    },
    currentId: state => {
      return state.timeline2.find(i => i.index === state.active.index).id
    },
    audioState: state => {
      return state.audioState
    },
    imagesToPreload: state => {
      let imagesArray = []
      state.timeline2.map((t) => {
        if (t.type === 'question') {
          imagesArray.push(t.preload)
        }
      })
      return imagesArray.flat()
    },
    formOffers: state => {
      return state.formOffers
    }
  },
  modules: {
  },
  plugins: [new VuexPersistence({
    storage: window.localStorage,
    key: window.pageMode + 'V3ocs',
  }).plugin]
})
